var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.shop === 'Gracz')?_c('div',[_c('OrderDetailGracz')],1):(_vm.shop === 'Rattana')?_c('div',[_c('OrderDetailRattana')],1):(_vm.shop === 'Sale Order')?_c('div',[_c('OrderDetailSaleOrder')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }